export type MediaType = "movie" | "drama";
export type Region = "日本" | "韩国";

export interface TitleItem {
  id: string;
  title: string;
  originalTitle: string;
  type: MediaType;
  year: number;
  region: Region;
  genre: string[];
  rating: number;
  episodes: string;
  cast: string[];
  director: string;
  poster: string;
  backdrop: string;
  tagline: string;
  synopsis: string;
  heat: number;
  isNew: boolean;
  featured: boolean;
}

export const titles: TitleItem[] = [
  {
    id: "tokyo-silent-tide",
    title: "东京静默之潮",
    originalTitle: "東京サイレント・タイド",
    type: "movie",
    year: 2026,
    region: "日本",
    genre: ["悬疑", "剧情"],
    rating: 8.7,
    episodes: "1 部电影 · 128 分钟",
    cast: ["松本遥", "中村翔太", "小林绘里"],
    director: "菅野和也",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20mystery%20film%20poster%20art%2C%20a%20lone%20silhouette%20standing%20on%20a%20rain-soaked%20Tokyo%20crossing%20at%20night%2C%20deep%20midnight%20blue%20tones%20with%20a%20warm%20amber%20street%20lamp%20glow%2C%20subtle%20film%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=600&height=900&seq=jk-movie-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20rainy%20Tokyo%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20blue%20atmosphere%20with%20amber%20warm%20highlights%2C%20lonely%20figure%20with%20umbrella%2C%20atmospheric%20film%20still%2C%20soft%20bokeh%2C%20dark%20moody%20lighting&width=1920&height=1080&seq=jk-movie-back-01&orientation=landscape",
    tagline: "当整座城市安静下来，真相才开始呼吸。",
    synopsis:
      "一场发生在东京凌晨三点的离奇失踪案，让沉默寡言的刑警神谷透被卷入城市最深的暗流。唯一的线索，是一盘没有声音的录音带。随着调查深入，他发现案件与自己十二年前未能破获的那桩旧案彼此交错，而所有相关人员都在刻意遗忘同一天的记忆。在喧嚣都市的静默缝隙里，他必须做出选择——是继续沉睡，还是让真相的潮水淹没人性最后的堤岸。",
    heat: 98,
    isNew: true,
    featured: true,
  },
  {
    id: "seoul-late-night-clinic",
    title: "首尔深夜诊所",
    originalTitle: "서울 심야 진료소",
    type: "drama",
    year: 2026,
    region: "韩国",
    genre: ["医疗", "治愈", "都市"],
    rating: 9.1,
    episodes: "全 16 集 · 更新至第 12 集",
    cast: ["李瑞妍", "姜道贤", "崔敏珠", "朴志勋"],
    director: "郑雨成",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20Korean%20medical%20drama%20poster%20art%2C%20a%20young%20female%20doctor%20in%20a%20white%20coat%20standing%20under%20a%20glowing%20sign%20at%20night%2C%20deep%20navy%20blue%20background%20with%20amber%20window%20light%2C%20editorial%20soft%20lighting%2C%20clean%20minimal%20poster%20composition%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Night%20view%20of%20a%20small%20Seoul%20neighborhood%20clinic%2C%20warm%20amber%20window%20light%20spilling%20onto%20a%20quiet%20street%2C%20deep%20navy%20blue%20sky%2C%20soft%20rain%2C%20cinematic%20television%20drama%20still%2C%20cozy%20intimate%20atmosphere&width=1920&height=1080&seq=jk-drama-back-02&orientation=landscape",
    tagline: "凌晨亮着灯的那扇窗，收留每个睡不着的人。",
    synopsis:
      "在首尔一条老巷子的尽头，有一间只在夜里十一点到清晨五点开门的诊所。主治医生车恩书白天拒绝一切社交，夜里却耐心接诊每一位被城市磨伤的人：失眠的编剧、失声的歌手、带着孩子独自撑起餐馆的单亲母亲。她治病，也治那些说不出口的疲惫。而当一位每周都来、却从不肯说出名字的病人出现后，她尘封多年的过去，开始一页页翻开。",
    heat: 100,
    isNew: true,
    featured: true,
  },
  {
    id: "kyoto-letter-season",
    title: "京都四季来信",
    originalTitle: "京都の四季の手紙",
    type: "movie",
    year: 2025,
    region: "日本",
    genre: ["爱情", "文艺"],
    rating: 8.4,
    episodes: "1 部电影 · 112 分钟",
    cast: ["藤井美咲", "佐藤悠人"],
    director: "水野真澄",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20Japanese%20romance%20film%20poster%20art%2C%20a%20young%20woman%20reading%20a%20letter%20under%20red%20maple%20leaves%20in%20a%20Kyoto%20temple%2C%20muted%20navy%20blue%20shadows%20with%20warm%20orange%20foliage%2C%20soft%20natural%20light%2C%20elegant%20minimal%20editorial%20layout%2C%20no%20text&width=600&height=900&seq=jk-movie-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Kyoto%20stone%20path%20lined%20with%20traditional%20wooden%20houses%20in%20autumn%2C%20red%20and%20orange%20maple%20leaves%2C%20cool%20blue%20morning%20mist%2C%20cinematic%20wide%20shot%2C%20serene%20melancholic%20mood%2C%20soft%20diffused%20daylight&width=1920&height=1080&seq=jk-movie-back-03&orientation=landscape",
    tagline: "四季轮转，我始终在同一个信箱前等你。",
    synopsis:
      "在京都一家老式文具店里，女孩千夏偶然发现了一叠写给“未来的自己”的信。写信的人是她从未见过的少年，信里记录着一整个四季里他对某个人的心事。千夏循着信中的地点走过春樱、夏祭、秋枫与冬雪，试图拼凑出信主人的模样。她不知道的是，这些信原本就是为了被某个人拾到而写下的，而那个人，或许正是她。",
    heat: 91,
    isNew: true,
    featured: true,
  },
  {
    id: "busan-blue-line",
    title: "釜山蓝线",
    originalTitle: "부산 블루 라인",
    type: "drama",
    year: 2025,
    region: "韩国",
    genre: ["犯罪", "悬疑", "都市"],
    rating: 8.9,
    episodes: "全 12 集 · 已完结",
    cast: ["申宇宰", "韩素熙", "金泰成"],
    director: "卢承焕",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20Korean%20drama%20poster%2C%20two%20figures%20standing%20on%20a%20seaside%20railway%20bridge%20in%20Busan%20at%20dusk%2C%20deep%20navy%20and%20teal%20color%20grading%20with%20orange%20sun%20glow%2C%20tense%20cinematic%20mood%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Busan%20harbor%20at%20dusk%2C%20cargo%20containers%20and%20a%20long%20railway%20bridge%20over%20dark%20water%2C%20deep%20navy%20blue%20sky%20with%20orange%20horizon%20glow%2C%20cinematic%20wide%20establishing%20shot%2C%20gritty%20crime%20film%20atmosphere&width=1920&height=1080&seq=jk-drama-back-04&orientation=landscape",
    tagline: "海岸线上，每一条铁轨都通向秘密。",
    synopsis:
      "釜山港的夜班调度员在一列货运火车上发现了不该出现的集装箱。为了查清弟弟失踪的真相，他被迫与一名被停职的海警记者联手，沿着海岸线一路追查。这条蓝色线路上运输的，不只是货物，还有交易、谎言和被人刻意抹去的名字。当权力与亲情的重量同时压来，他们必须在潮水退去之前，找到那个唯一能作证的人。",
    heat: 95,
    isNew: false,
    featured: true,
  },
  {
    id: "spring-i-left-behind",
    title: "我留下的那个春天",
    originalTitle: "私が残した春",
    type: "drama",
    year: 2026,
    region: "日本",
    genre: ["青春", "校园", "治愈"],
    rating: 8.6,
    episodes: "全 10 集 · 更新至第 6 集",
    cast: ["森川葵", "大柴亮", "石川奈奈"],
    director: "近藤纱良",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20youth%20coming-of-age%20drama%20poster%2C%20high%20school%20students%20walking%20under%20cherry%20blossoms%20along%20a%20river%2C%20soft%20pink%20blooms%20against%20deep%20navy%20blue%20evening%20sky%2C%20gentle%20nostalgic%20lighting%2C%20minimal%20elegant%20poster%20composition%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Riverside%20path%20in%20a%20Japanese%20town%20covered%20with%20cherry%20blossom%20petals%20floating%20in%20the%20wind%2C%20dusk%20blue%20sky%20with%20warm%20pink%20and%20orange%20light%2C%20cinematic%20nostalgic%20film%20still%2C%20dreamy%20soft%20focus&width=1920&height=1080&seq=jk-drama-back-05&orientation=landscape",
    tagline: "有些告别，用了整整一个春天说完。",
    synopsis:
      "高中三年级的最后一个春天，转学生七海加入了即将被解散的校园放送部。为了留下证明自己存在过的痕迹，四个少年决定做一档只播放给未来的广播节目。他们在樱花树下录下心愿，在毕业倒计时里偷偷喜欢，也在某个雨夜明白了成长意味着放手。多年之后，当这卷磁带被人重新播放，那个春天又一次开始了。",
    heat: 89,
    isNew: true,
    featured: false,
  },
  {
    id: "manhattan-seoul-kitchen",
    title: "曼哈顿首尔食堂",
    originalTitle: "맨해튼 서울 식당",
    type: "drama",
    year: 2025,
    region: "韩国",
    genre: ["美食", "温情", "生活"],
    rating: 8.5,
    episodes: "全 16 集 · 已完结",
    cast: ["尹夏恩", "李度允", "赵成民"],
    director: "宋志浩",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20food%20healing%20drama%20poster%2C%20a%20warm%20steaming%20bowl%20of%20food%20on%20a%20wooden%20table%20inside%20a%20small%20restaurant%2C%20deep%20navy%20interior%20with%20amber%20warm%20lamp%20light%2C%20inviting%20cozy%20cinematic%20still%20life%2C%20editorial%20poster%20layout%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20cozy%20Korean%20restaurant%20interior%20in%20Manhattan%20at%20night%2C%20warm%20amber%20pendant%20lights%20over%20a%20wooden%20counter%2C%20steam%20rising%20from%20bowls%2C%20deep%20navy%20blue%20shadow%20outside%20the%20window%2C%20cinematic%20warm%20atmosphere&width=1920&height=1080&seq=jk-drama-back-06&orientation=landscape",
    tagline: "异乡的第一口饭，往往是最想家的那口。",
    synopsis:
      "曾在首尔一间米其林餐厅做副厨的尹夏恩，因为一次意外失去了味觉的判断力，只好远走纽约，在曼哈顿下城开了一间只有八个座位的小食堂。她的客人来自世界各地：加班到深夜的会计师、刚被解雇的舞者、每周三固定来吃泡菜的退休教师。一碗热汤，成了那些人在这座城市里找到的唯一坐标。而她自己的味道，也在慢慢回来。",
    heat: 87,
    isNew: false,
    featured: false,
  },
  {
    id: "the-mountain-sleeps",
    title: "山在沉睡",
    originalTitle: "山は眠る",
    type: "movie",
    year: 2024,
    region: "日本",
    genre: ["剧情", "家庭"],
    rating: 8.8,
    episodes: "1 部电影 · 136 分钟",
    cast: ["田中一郎", "白川美和", "小野寺圭"],
    director: "安藤广志",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20family%20drama%20film%20poster%2C%20an%20elderly%20man%20standing%20on%20a%20misty%20mountain%20trail%2C%20deep%20navy%20blue%20fog%20with%20a%20small%20warm%20orange%20lantern%20glow%2C%20quiet%20melancholic%20cinematic%20photography%2C%20minimal%20poster%20design%2C%20no%20text&width=600&height=900&seq=jk-movie-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Misty%20mountain%20forest%20at%20dawn%2C%20layers%20of%20deep%20navy%20blue%20fog%20between%20pine%20trees%2C%20faint%20warm%20orange%20sunrise%20breaking%20through%2C%20cinematic%20wide%20landscape%2C%20serene%20quiet%20atmosphere&width=1920&height=1080&seq=jk-movie-back-07&orientation=landscape",
    tagline: "他一生都在山脚下，却从未真正离开过山。",
    synopsis:
      "退休伐木工佐藤一郎在妻子去世后，独自守着山脚下的老屋。长子希望他去城里同住，次女则主张卖掉房产，三人多年积累的矛盾在一次归乡中爆发。为了完成妻子留下的最后一个愿望，一郎决定重新走一遍年轻时开凿的山路。一路上的风雪、旧识和沉默，逼着他面对那些从未说出口的话。",
    heat: 84,
    isNew: false,
    featured: false,
  },
  {
    id: "signal-from-room-704",
    title: "704 房间的信号",
    originalTitle: "704호의 신호",
    type: "movie",
    year: 2026,
    region: "韩国",
    genre: ["科幻", "惊悚"],
    rating: 8.3,
    episodes: "1 部电影 · 119 分钟",
    cast: ["郑彩媛", "吴振宇", "徐恩静"],
    director: "白承民",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20sci-fi%20thriller%20film%20poster%2C%20a%20glowing%20doorway%20at%20the%20end%20of%20a%20dark%20hotel%20corridor%2C%20deep%20navy%20blue%20shadows%20with%20intense%20amber%20light%20spill%2C%20eerie%20cinematic%20atmosphere%2C%20high%20contrast%20minimal%20poster%2C%20no%20text&width=600&height=900&seq=jk-movie-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20old%20hotel%20corridor%20at%20night%2C%20repeating%20doors%2C%20sickly%20amber%20light%20under%20one%20door%2C%20deep%20navy%20blue%20darkness%20elsewhere%2C%20cinematic%20sci-fi%20thriller%20establishing%20shot%2C%20unsettling%20mood&width=1920&height=1080&seq=jk-movie-back-08&orientation=landscape",
    tagline: "那间房每年只在同一天出现。",
    synopsis:
      "网络工程师金多恩接到一份奇怪的委托：修复一栋废弃酒店里断线二十年的内部通讯系统。调试当晚，她从 704 房间收到一段不属于任何时间线的信号。录音里的声音，是三个月前失踪的妹妹。为了找到答案，她必须在酒店被拆除之前，解开那个房间每一次出现背后的规律，并接受一个残酷的可能——信号那头的人，也许正在等待她做出同样的选择。",
    heat: 92,
    isNew: true,
    featured: false,
  },
  {
    id: "ramen-and-the-rain",
    title: "拉面与雨",
    originalTitle: "ラーメンと雨",
    type: "drama",
    year: 2025,
    region: "日本",
    genre: ["生活", "美食", "治愈"],
    rating: 8.2,
    episodes: "全 12 集 · 已完结",
    cast: ["高桥凉介", "宫本春菜"],
    director: "远藤悟",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20slice-of-life%20drama%20poster%2C%20a%20small%20ramen%20shop%20counter%20with%20steaming%20noodle%20bowl%2C%20rain%20streaks%20on%20the%20window%2C%20deep%20navy%20blue%20exterior%20and%20warm%20amber%20interior%20glow%2C%20cozy%20cinematic%20still%20life%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Narrow%20Japanese%20alley%20on%20a%20rainy%20evening%2C%20small%20ramen%20shop%20with%20warm%20amber%20lantern%20and%20noren%20curtain%2C%20dark%20navy%20blue%20wet%20pavement%20reflections%2C%20cinematic%20gentle%20mood&width=1920&height=1080&seq=jk-drama-back-09&orientation=landscape",
    tagline: "雨天来的人，都有一个不想说出口的故事。",
    synopsis:
      "在一家只有雨天才会满座的老式拉面店里，老板阿凉每天只做三十碗面。他记得每一位常客的口味，也记得他们故事里的停顿。失业的中年人、备考失败的少女、即将离开这座城市的情侣，都在雨声里吃完了自己那一碗。而阿凉自己，也在等一个二十年没再来过的人。",
    heat: 80,
    isNew: false,
    featured: false,
  },
  {
    id: "gangnam-tempo",
    title: "江南节拍",
    originalTitle: "강남 템포",
    type: "drama",
    year: 2026,
    region: "韩国",
    genre: ["音乐", "励志", "都市"],
    rating: 8.4,
    episodes: "全 14 集 · 更新至第 9 集",
    cast: ["朴世勋", "金多美", "柳河俊", "姜素拉"],
    director: "玄志勋",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20music%20drama%20poster%2C%20a%20silhouette%20of%20a%20dancer%20under%20stage%20lights%20in%20a%20dark%20club%2C%20deep%20navy%20blue%20shadows%20with%20strong%20amber%20spotlight%20and%20orange%20haze%2C%20energetic%20cinematic%20poster%20design%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20music%20rehearsal%20studio%20at%20night%20with%20a%20microphone%20stand%2C%20amber%20spotlight%20cutting%20through%20haze%2C%20deep%20navy%20blue%20background%2C%20cinematic%20moody%20concert%20atmosphere%2C%20soft%20lens%20flare&width=1920&height=1080&seq=jk-drama-back-10&orientation=landscape",
    tagline: "在这个城市，节拍比心跳更诚实。",
    synopsis:
      "曾经在地下乐队里最有天赋的鼓手朴世勋，在三十岁那年丢掉了工作、乐队和住处。为了偿还债务，他成了一个给练习生打伴奏的临时乐手。直到某天，一个不肯按谱子唱歌的女孩闯进录音室。两个被行业抛弃的人，决定用一台旧合成器和一间地下室，重新找回属于自己的节拍。",
    heat: 93,
    isNew: true,
    featured: false,
  },
  {
    id: "snow-country-kiss",
    title: "雪国吻别",
    originalTitle: "雪国のくちづけ",
    type: "movie",
    year: 2024,
    region: "日本",
    genre: ["爱情", "剧情"],
    rating: 8.1,
    episodes: "1 部电影 · 124 分钟",
    cast: ["山本千夏", "伊藤健"],
    director: "桥本雄一",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20snow%20country%20romance%20film%20poster%2C%20two%20figures%20in%20winter%20coats%20standing%20apart%20on%20a%20snowy%20street%20at%20dusk%2C%20cool%20blue%20snow%20with%20warm%20orange%20window%20light%2C%20cinematic%20melancholic%20poster%20photography%2C%20no%20text&width=600&height=900&seq=jk-movie-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20snowy%20Japanese%20village%20at%20dusk%2C%20wooden%20houses%20with%20warm%20orange%20windows%2C%20deep%20blue%20snowfall%20and%20mountains%2C%20cinematic%20wide%20shot%2C%20quiet%20melancholic%20winter%20atmosphere&width=1920&height=1080&seq=jk-movie-back-11&orientation=landscape",
    tagline: "有些爱，只在雪落下的那一刻成立。",
    synopsis:
      "在北方雪国的小站，摄影师雪村遥每年冬天都会回来一次。她与车站值班员伊藤健之间有一个不成文的约定：只在雪夜里相见，从不过问彼此的城市与生活。第十个冬天，伊藤终于要离开这里。当列车时刻表被改写，两个人必须决定，这份只存在于雪中的感情，是否值得一次真正的告别。",
    heat: 82,
    isNew: false,
    featured: false,
  },
  {
    id: "daejeon-line-7",
    title: "大田七号线",
    originalTitle: "대전 7호선",
    type: "drama",
    year: 2024,
    region: "韩国",
    genre: ["悬疑", "犯罪"],
    rating: 8.7,
    episodes: "全 10 集 · 已完结",
    cast: ["权赫秀", "李娜英", "张贤宇"],
    director: "车民宰",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20mystery%20drama%20poster%2C%20an%20empty%20subway%20platform%20at%20night%20with%20one%20figure%20standing%20at%20the%20edge%2C%20deep%20navy%20blue%20tones%20with%20a%20single%20amber%20emergency%20light%2C%20tense%20cinematic%20poster%2C%20no%20text&width=600&height=900&seq=jk-drama-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20Korean%20subway%20platform%20at%20late%20night%2C%20tunnel%20stretching%20into%20darkness%2C%20deep%20navy%20blue%20tiles%20and%20cold%20amber%20lighting%20strips%2C%20cinematic%20thriller%20establishing%20shot%2C%20eerie%20quiet&width=1920&height=1080&seq=jk-drama-back-12&orientation=landscape",
    tagline: "这条线没有终点站。",
    synopsis:
      "大田地铁七号线是一条在规划图上被抹掉的线路。资深刑警权赫秀在调查一起连环失踪案时，所有线索都指向了这条不存在的轨道。唯一的证人是一位每晚都坐末班车、却从不下车的老人。随着列车一次次驶过同一个不存在的站台，赫秀逐渐意识到，有人正在用整座城市的记忆，做一场精密的实验。",
    heat: 88,
    isNew: false,
    featured: false,
  },
];